import toList, { toHTML } from "../utils/ComponentUtil";
import './Talent.scss';
import { FastForward, KeyboardDoubleArrowRight, Place } from "@mui/icons-material";
import Carousel from "../utils/Carousel";
import { Link } from "react-router-dom";

function TalentTemplate({ talentDesc }) {

  return (
    <>
      <div className="talent-desc">
        <div className="talent-title">{talentDesc?.title}</div>
        <div className="user-details">
          <div className="user">
            <img className="profile-pic" src={talentDesc?.user?.img} alt="profile-pic" />
            <div className="name-location">
              <div className="name">{talentDesc?.user?.name}</div>
              <div className="location">
                <Place className="icon"/>
                <div className="place">{talentDesc?.user?.location}</div>
              </div>
            </div>
          </div>
          <div className="date">{talentDesc?.postedDate}</div>
        </div>
        <div className="featured-images">
          <Carousel numberOfCards={1} tabCards={1} cards={toList(talentDesc?.featuredImages, undefined, (image, i) =>
                    <div className='feature-image' key={i}>
                        <img className="feature-image" src={image} alt='feature' />
                    </div>
                )}/>
        </div>
        <div className="salient-features">
          <div className="salient-features-wrp">
            <div className="title">Salient Features:</div>
            <div className="features">
              <div className="features-wrp">
                {toList(talentDesc?.salientFeatures, undefined, (item, i) =>
                  <div className="feature" key={i}>
                    <div className="title">
                      <img className="icon"  src={item?.img} alt={item?.name} />
                      <div className="name">{item?.name}</div>
                    </div>
                    {item?.content && <div className="content">{item?.content}</div>}
                    {item?.contents && <div className="contents">
                      {
                        toList(item?.contents, undefined, (content, j) =>
                          <div className="content">
                            <div className="name">{content?.name}</div>
                            <div className="link">{content?.link}</div>
                          </div>
                        )
                      }
                    </div>}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="about-talent">
          <div className="about-title">About This Talent</div>
          <div className="process-steps">
            <div className="step">
              <div className="process-heading">
                My Process of the Working with Clients
              </div>
              <div className="process-intro">{talentDesc?.processIntro}</div>
            </div>
            {
              toList(talentDesc?.processSteps, undefined, (step, i) =>
                <div className="step" key={i}>
                  <div className="heading">
                    <KeyboardDoubleArrowRight className="icon" />
                    <div className="name">Step {i + 1}</div>
                  </div>
                  <div className="content">{step}</div>
                </div>)
            }
          </div>
          <div className="advantages">
            <div className="title">What are some advantages of hiring me?</div>
            <div className="contents">
              {toHTML(talentDesc?.advantages)}
            </div>
          </div>
          <div className="faqs">
            <div className="heading">
              Some Common FAQs Related to My Graphic Design Work
            </div>
            {toList(talentDesc?.faqs, undefined, (faq, i) =>
              <div className="faq">
                <div className="question">
                  <FastForward/>
                  <div className="content">{faq?.question}</div>
                </div>
                <div className="answer">{faq?.answer}</div>
              </div>
            )}
          </div>
          <div className="hire-btn">
            <div className="text"> <Link reloadDocument={true} to='./hire'>Hire This Talent</Link></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TalentTemplate;
